import styled from "styled-components"

const StyledStrategyHeader = styled.header`
  max-width: 665px;
  text-align: center;
  padding: 0 15px;
  margin: 50px auto 40px;

  .title {
    text-transform: uppercase;
    margin-bottom: 29px;
  }

  .desc {
    margin-bottom: 30px;

    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
`
export default StyledStrategyHeader
